const TransformerFormFields = {
    id: "id",
    ratedKva: "ratedKva",
    secondaryVoltage: "secondaryVoltage",
    impedence: "impedence",
    bindingConfiguration: "bindingConfiguration"
}
export default TransformerFormFields;